/**
 * @flow
 * @relayHash 2d9ba685416a91ca1f2b0aa776d036bd
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CreateVideoAdLogInput = {|
  userId: string,
  clientMutationId?: ?string,
|};
export type CreateVideoAdLogMutationVariables = {|
  input: CreateVideoAdLogInput
|};
export type CreateVideoAdLogMutationResponse = {|
  +createVideoAdLog: ?{|
    +VideoAdLog: ?{|
      +id: string
    |}
  |}
|};
export type CreateVideoAdLogMutation = {|
  variables: CreateVideoAdLogMutationVariables,
  response: CreateVideoAdLogMutationResponse,
|};
*/


/*
mutation CreateVideoAdLogMutation(
  $input: CreateVideoAdLogInput!
) {
  createVideoAdLog(input: $input) {
    VideoAdLog {
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateVideoAdLogInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "createVideoAdLog",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateVideoAdLogPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "VideoAdLog",
        "storageKey": null,
        "args": null,
        "concreteType": "VideoAdLog",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "CreateVideoAdLogMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "CreateVideoAdLogMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "CreateVideoAdLogMutation",
    "id": null,
    "text": "mutation CreateVideoAdLogMutation(\n  $input: CreateVideoAdLogInput!\n) {\n  createVideoAdLog(input: $input) {\n    VideoAdLog {\n      id\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'd10186944c48b2217af3defa320c2f79';
module.exports = node;
